module.exports = __webpack_public_path__ + "img/cert1.2e38464e.png";